import { Box, Typography, TypographyProps } from "@mui/material";
import React, { useState } from "react";

type ToggleTypographyProps = TypographyProps & {
    content: string;
}

export const ToggleTypography: React.FC<ToggleTypographyProps> = ({ content, ...props }) => {
    const [expanded, setExpanded] = useState(false);

    const toggleExpanded = () => {
        setExpanded(!expanded);
    };

    return (
        <Box>
            <Typography
                {...props}
                sx={{
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    WebkitLineClamp: expanded ? "none" : 2, // Show 2 lines when not expanded
                    ...props.sx
                }}
            >
                {content ?? "-"}
            </Typography>
            {content && content.split("\n").length > 2 && (
                <Box display={"flex"} justifyContent={"flex-start"}>
                    <Typography
                        variant="caption"
                        sx={{ 
                            marginTop: 0.25,
                            fontSize: 9, 
                            textTransform: "none", 
                            padding: 0, 
                            color: "primary.main", 
                            cursor: "pointer",
                            ':hover': { textDecoration: "underline" }
                         }}
                        component="span"
                        onClick={toggleExpanded}
                    >
                        {expanded ? "Show less" : "Show more"}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};
